import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import { ReactNode, useMemo } from 'react';
import styles from '../DragAndDrop.module.scss';

export interface IDragAndDropContext {
    dragIndicatorIcon: ReactNode | null;
    dragProps: {
        reference: (node: HTMLElement | null) => void;
        style: React.CSSProperties;
        isDragging: boolean;
    };
}

const useDragAndDrop = (identifierId: UniqueIdentifier, isEditMode: boolean): IDragAndDropContext => {
    const { attributes, listeners, setNodeRef, isDragging } = useSortable({
        id: identifierId,
    });

    const dragStyle: React.CSSProperties = useMemo(
        () => ({
            opacity: isDragging ? 0.5 : 1,
        }),
        [isDragging],
    );

    const dragIndicatorIcon = useMemo(() => {
        if (!isEditMode) {
            return <> </>;
        }

        return (
            <div className={styles.dragAndDrop_drag_indicator} {...listeners} {...attributes}>
                <DragIndicatorOutlinedIcon />
            </div>
        );
    }, [isEditMode, listeners, attributes]);

    return {
        dragIndicatorIcon,
        dragProps: {
            reference: setNodeRef,
            style: dragStyle,
            isDragging,
        },
    };
};

export default useDragAndDrop;
